var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.002,
    height: 64.001,
    viewBox: "0 0 64.002 64.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-big-arrow",
    transform: "translate(6.986 -0.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30580",
    "data-name": "Rectangle 30580",
    width: 64,
    height: 64,
    transform: "translate(-6.986 0.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark",
    transform: "translate(-6.985 0.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296504",
    "data-name": "Path 296504",
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0Zm0,58A26,26,0,1,1,58,32,26,26,0,0,1,32,58Zm0-43.966c-2.292,0-4.026,1.2-4.026,3.128v17.72c0,1.934,1.734,3.126,4.026,3.126,2.236,0,4.026-1.242,4.026-3.126V17.162C36.028,15.276,34.238,14.034,32,14.034ZM32,42a3.994,3.994,0,1,0,3.992,4A4,4,0,0,0,32,42Z",
    fill: "#f54c52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamationIcon);
export default __webpack_public_path__ + "static/media/red-exclamation-icon.0702a912494b23ca14676af642738460.svg";
export { ForwardRef as ReactComponent };